import { keyframes, styled } from 'theme'
import { Grid, MenuList as menuList, Paper as paper } from '@mui/material'
import { Box, Button, Flex, h5Styles, paraStyles } from 'components/elements'
import { Link } from 'react-router-dom'
import AudioPlayer from 'react-h5-audio-player'

export const AudioPlayerWrap = styled(AudioPlayer, {})
export const GridBox = styled(Grid, {
  '&.MuiGrid-root': {
    'mt': 0,
    '&.MuiGrid-item': {
      pt: 0,
    },
  },
})
export const Span = styled('span', {})
export const MenuList = styled(menuList, {
  '&.MuiList-root': {
    position: 'static',
    overflow: 'auto',
    p: 0,
  },
})
export const Paper = styled(paper, {})
export const LinkItem = styled(Link, {
  display: 'flex',
})
export const ToggleButtonWrap = styled(Button, {
  position: 'absolute',
  top: 15,
  zIndex: 2,
  left: 15,
})
export const ButtonTransparent = styled(Button, {})
export const AutoplayButtonWrap = styled(Button, {
  position: 'absolute',
  bottom: 15,
  zIndex: 2,
  left: 15,
  p: '$space$6',
  borderRadius: '$rounded',
})
export const scrollBar = {
  '&::-webkit-scrollbar': {
    width: 8,
    height: 8,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
    borderRadius: 0,
    my: '$space$8',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '$border',
    width: 8,
    borderRadius: 8,
  },
}
export const BoxPageWrap = styled(Box, {
  // m: '0 auto',
  'boxShadow': '$pageBoxShadow',
  'p': '$space$24 $space$32 $space$0',
  'borderRadius': '$base',
  'background': '$whiteBase',
  'maxWidth': 740,
  'width': '100%',
  // 'overflow': 'auto',
  // 'height': 'calc(100vh - 127px)',
  // ...scrollBar,
  '@media (max-width: 812px)': {
    borderRadius: '$space$0',
    maxWidth: '100%',
    p: '$16',
  },
  '@media (max-width: 480px)': {
    p: '$16',
  },
  // ...scrollBar,
})
export const VideoFooter = styled(Flex, {
  mt: '$space$10',
  mb: '$space$15',
})
export const ReportHeader = styled(Flex, {
  'py': '$space$15',
  'mb': '$space$20',
  // 'borderBottom': '1px solid $border',
  'flexDirection': 'column-reverse',
  '@media(min-width: 600px)': {
    flexDirection: 'column',
  },
})
export const ReportDetailWrap = styled(Flex, {
  'width': '100%',
  '@media(min-width: 600px)': {
    width: '50%',
  },
})
export const ReportLink = styled(Box, {
  pb: '$space$15',
  borderBottom: '1px solid $borderDark',
})

export const GroupIconCss = {
  borderWidth: 8,
  borderStyle: 'solid',
  p: '$space$6',
  borderRadius: '$radii$rounded',
}

export const TitleList = styled(Flex, {
  // my: '$space$15',
  background: '$gray300',
  p: '$space$12 $space$15',
  border: '1px solid $border',
})
export const SecondaryIcon = styled(Flex, {
  // ml: '$space$50',
})
export const ValueTextContainer = styled(Flex, {})
export const ValueContainer = styled(Flex, {
  pr: '$space$20',
})
export const IconContainer = styled(Flex, {})
// export const DescriptionContainer = styled(Flex, {
//   width: '100%',
//   // '@media(min-width: 600px)': {
//   //   maxWidth: `calc(100% - 300px)`,
//   // },
// })

export const DescriptionContainer = styled('div', {
  'display': 'grid',
  'alignItems': 'flex-start',
  'width': '100%',
  'gap': '$space$8',
  'variants': {
    columns: {
      1: { gridTemplateColumns: '1fr' },
      2: { gridTemplateColumns: '2fr 5fr' },
      3: { gridTemplateColumns: '2fr 1fr 4fr' },
      4: { gridTemplateColumns: '2fr 1fr 4fr 2fr' },
    },
  },
  'defaultVariants': {
    columns: 1,
  },
  '@media (max-width: 600px)': {
    'gridTemplateColumns': '1fr',
    '&[data-columns="2"]': { gridTemplateColumns: '1fr' },
    '&[data-columns="3"]': { gridTemplateColumns: '1fr' },
    '&[data-columns="4"]': { gridTemplateColumns: '1fr' },
  },
})

export const Header = styled('header', {
  background: '$whiteBase',
  p: '$space$10',
  boxShadow: '$headerShadow',
})
export const Footer = styled('footer', {
  textAlign: 'end',
  background: '$whiteBase',
  borderTopLeftRadius: '$radii$md',
  borderTopRightRadius: '$radii$md',
  p: '$space$15',
  a: { pr: '$space$10' },
})
export const List = styled('li', {
  ...paraStyles,
  pb: '$space$6',
  counterIncrement: 'section',
})
export const UnorderList = styled('ul', {
  m: 0,
  pl: 0,
})
export const OrderList = styled('ol', {
  m: 0,
  pl: '$space$16',
  counterReset: 'section',
  li: {
    'listStyle': 'none',
    '&:before': {
      content: 'counters(section, ".") ". "',
    },
  },
})
export const overflowText = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
}
export const defaultImage = {
  // '@media(min-width: 600px)': {
  //   ml: '$space$25',
  //   mb: 0,
  // },
  // 'mb': '$space$10',
  height: 'auto',
  objectFit: 'contain',
  boxShadow: 'none',
  borderRadius: 'initial',
}
export const DropdownWrap = {
  mt: '$space$4',
  border: '1px solid',
  borderColor: '$border',
  borderRadius: '$xs',
  boxShadow: '$dropdownBoxShadow',
  backgroundColor: '$colors$dropdownBg',
}
export const DropdownList = {
  ...h5Styles,
  'cursor': 'pointer',
  'color': '$inputText',
  'textAlign': 'left',
  'mb': '$space$2',
  '&:hover': {
    backgroundColor: '$gray50',
  },
}
export const DropdownCss = {
  '&.dropdown': {
    'position': 'relative',
    'button': {
      justifyContent: 'space-between',
      pr: '$size$12',
      transition: 'all 0.6s $transition$easeOutQuint',
      svg: {
        transition: 'transform 0.6s $transition$easeOutQuint',
      },
    },
    'button, label': {
      width: '100%',
    },
    '&Hide': {
      position: 'absolute',
      opacity: 0,
      PointerEvent: 'none',
      zIndex: '-10',
    },
    '.Mui': {
      '&Popper': {
        '&-root': {
          width: '100%',
          zIndex: 10,
        },
      },
      '&Paper': {
        '&-root': {
          ...DropdownWrap,
        },
      },
      '&List': {
        '&-root': {
          'maxHeight': 250,
          'overflowY': 'auto',
          ...scrollBar,
          '&::-webkit-scrollbar': {
            width: 6,
          },
        },
      },
    },
    '[aria-expanded="true"]': {
      'borderColor': '$dropdownBorderFocus',
      'boxShadow': '$inputShadow',
      '.MuiSvgIcon': {
        '&-root': {
          transform: 'rotate(180deg)',
        },
      },
    },
  },
  '.dropdown': {
    '&List': {
      ...DropdownList,
      pb: 0,
    },
  },
}
export const shimmer = keyframes({
  '0%': {
    backgroundPosition: '-1000px 0px',
  },
  '100%': {
    backgroundPosition: '1000px 0px',
  },
})
